/**
 * Created by karora on 17/02/18.
 */
export class IssueAction {
  issue_id: number;
  occurred: string;
  action_type: number;
  action_text: string;
  type_text: string;
  took_minutes: number;
  user_profile_id: string;
  user_profile_type: number;
}
